<template>
  <v-hover v-slot="{ hover }">
    <v-card :elevation="hover ? 5 : 0" class="container-item" @click="removerFiltro">
      <div class="container-dentista-evento" :style="`--cor-dentista: ${dentistaSelecionado.corIdentificacao}`">
        <div class="container-foto-dentista">
          <foto-avatar :foto-url="dentistaSelecionado.foto" class-avatar="imagem-dentista"/>
        </div>
        <div class="container-info-dentista">
          <div class="selecionado-label">
            <span class="primary--text" style="font-size: 14px">Nome</span>
            <p>{{ dentistaSelecionado.nome }}</p>
          </div>
          <div class="selecionado-label ml-8">
            <span class="primary--text" style="font-size: 14px">Cargo</span>
            <p>{{ dentistaSelecionado.cargo }}</p>
          </div>
        </div>
      </div>
      <v-overlay :value="hover" absolute>
        <div>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon>
                <v-icon size="30" >mdi-close-circle</v-icon>
              </v-btn>
            </template>
            Remover filtro
          </v-tooltip>
        </div>
      </v-overlay>
    </v-card>
  </v-hover>
</template>

<script>

import FotoAvatar from '@/views/components/FotoAvatar.vue'

export default {
    name: 'CardDentistaSelecionado',
    components: {FotoAvatar},
    props: {
        dentistaSelecionado: {
            type: Object,
            required: true
        },
    },
    methods:{
        removerFiltro(){
            this.$emit('removerFiltroDentista')
        }
    }
}
</script>

<style scoped lang="stylus">

.container-dentista-evento
  background-color #E0E0E0
  height 65px
  padding 10px
  font-size 16px
  border-radius 5px
  display flex
  border-right-width 10px
  border-right-style solid
  border-right-color var(--cor-dentista)

.container-dentista-evento:hover
  cursor pointer

.container-foto-dentista
  margin-right 10px

.container-info-dentista
  width 100%
  display flex
  flex-direction row

.imagem-dentista
  width 40px
  height 40px
  border-radius 50%
  border 2px solid #eee


</style>